var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RoamTransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"isXSmall":_vm.isXSmall,"isLarge":_vm.isLarge,"formsConfig":_vm.formsConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }